<template>
    <transition :name="transitionName" @after-leave="handleAfterLeave">
        <div :class="[
                'yd-toast',
                typeClass,
                positionClass
            ]"
            v-show="visible"
        >
            <div :class="!message ? 'center' : ''">
                <img src="@images/icon/icon_toast_check@2x.png" srcset="@images/icon/icon_toast_check@3x.png 3x" v-if="type == 'success'" >
                <img src="@images/icon/icon_toast_error@2x.png" srcset="@images/icon/icon_toast_error@3x.png 3x" v-else-if="type == 'error'" >
                <img src="@images/icon/icon_toast_warning@2x.png" srcset="@images/icon/icon_toast_warning@3x.png 3x" v-else-if="type == 'warning'" >
                <svg v-else-if="type == 'loading'" :class="{'text': message}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="38px" height="38px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <defs>
                        <mask id="ldio-wpu335ko6i-mask">
                            <circle cx="50" cy="50" r="30" stroke="#fff" stroke-linecap="round" stroke-dasharray="141.37166941154067 47.12388980384689" stroke-width="6">
                                <animateTransform attributeName="transform" type="rotate" values="0 50 50;360 50 50" times="0;1" dur="1.8181818181818181s" repeatCount="indefinite"></animateTransform>
                            </circle>
                        </mask>
                    </defs>
                    <g mask="url(#ldio-wpu335ko6i-mask)">
                        <rect x="13.5" y="0" width="73" height="100" fill="#7ad21a">
                            <animate attributeName="fill" values="#7ad21a" times="0" dur="1.8181818181818181s" repeatCount="indefinite" begin="0s"></animate>
                        </rect>
                    </g>
                </svg>
                <span v-if="message">{{message}}</span>
            </div>
        </div>
    </transition>
</template>
<script>
const typeMap = {
    success: 'success',
    warning: 'warning',
    error: 'error',
    loading: 'loading'
};
const positionMap = {
    center: 'center',
    bottom: 'bottom'
};
export default {
    data(){
        return {
            visible: false,
            message: '',
            duration: 3000,
            type: null,
            position: null,
            onClose: null,
            closed: false,
            timer: null,
        }
    },
    computed: {
      typeClass() {
        return this.type ? typeMap[this.type] : '';
      },
      positionClass() {
        return `is-${this.position ? positionMap[this.position] || 'center' : 'center'}`;
      },
      transitionName(){
        return `toast-fade-${this.position ? positionMap[this.position] || 'center' : 'center'}`;
      }
    },
    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
        }
      }
    },
    mounted(){
        this.startTimer();
    },
    methods: {
      handleAfterLeave() {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },

      close() {
        this.closed = true;
        if (typeof this.onClose === 'function') {
          this.onClose(this);
        }
      },

      clearTimer() {
        clearTimeout(this.timer);
      },

      startTimer() {
        if (this.type !== 'loading' && this.duration > 0) {
          this.timer = setTimeout(() => {
            if (!this.closed) {
              this.close();
            }
          }, this.duration);
        }
      }
    }
}
</script>
<style lang="scss" scoped>
.toast-fade-center-enter-active {
    animation: C_an_in 0.25s;
}
.toast-fade-center-leave-active {
    animation: C_an_out 0.25s;
}
.toast-fade-bottom-enter-active {
    animation: B_an_in 0.25s;
}
.toast-fade-bottom-leave-active {
    animation: B_an_out 0.25s;
}
.yd-toast{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    z-index: 1000;
    pointer-events: none;
    &.is-center{
        top: 50%;
        transform: translateY(-50%);
    }
    &.is-bottom{
        top: 100%;
        transform: translateY(-250%);
    }
    > div{
        width: auto;
        height: auto;
        min-height: 92px;
        background: #ffffff;
        box-shadow: 0px 6px 20px -4px rgba(136,136,136,0.25);
        padding: 15px 35px;
        border-radius: 20px;
        color: #1B1C1E;
        font-size: 32px;
        font-weight: 400;
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        &.center{
            padding: 25px;
            img, svg{
                margin-right: 0;
            }
        }
        img{
            width: 38px;
            height: 38px;
            margin-right: 12px;
        }
        svg{
            width: 75px;
            height: 75px;
            margin-right: 12px;
            &.text{
                width: 65px;
                height: 65px;
            }
        }
        span{
            max-width: 500px;
            overflow: hidden;
            text-align: center;
        }
    }
}
@keyframes C_an_in{
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
@keyframes C_an_out{
    0%{
        opacity: 1;
    }
    100%{
        opacity: 0;
    }
}
@keyframes B_an_in{
    0%{
        transform: translateY(0%);
    }
    100%{
        transform: translateY(-250%);
    }
}
@keyframes B_an_out{
    0%{
        transform: translateY(-250%);
    }
    100%{
        transform: translateY(0%);
    }
}
</style>